import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import './Terms.css';

const Terms = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="terms-page">
      <Header />
      <main className="main-content">
        <div className="terms-container">
          <div className="terms-header">
            <h1 className="terms-title">{t('termsOfService')}</h1>
            <p className="terms-last-updated">
              {t('lastUpdated')}: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="terms-content">
            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection1Title')}</h2>
              <p className="terms-paragraph">{t('cguSection1Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection2Title')}</h2>
              <p className="terms-paragraph">{t('cguSection2Content')}</p>
              <ul className="terms-list">
                <li>{t('cguSection2Item1')}</li>
                <li>{t('cguSection2Item2')}</li>
                <li>{t('cguSection2Item3')}</li>
                <li>{t('cguSection2Item4')}</li>
                <li>{t('cguSection2Item5')}</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection3Title')}</h2>
              <p className="terms-paragraph">{t('cguSection3Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection4Title')}</h2>
              <p className="terms-paragraph">{t('cguSection4Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection5Title')}</h2>
              <p className="terms-paragraph">{t('cguSection5Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection6Title')}</h2>
              <p className="terms-paragraph">{t('cguSection6Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection7Title')}</h2>
              <p className="terms-paragraph">{t('cguSection7Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection8Title')}</h2>
              <p className="terms-paragraph">{t('cguSection8Content')}</p>
            </section>

            <section className="terms-section">
              <h2 className="terms-section-title">{t('cguSection9Title')}</h2>
              <p className="terms-paragraph">{t('cguSection9Content')}</p>
            </section>
          </div>

          <footer className="terms-footer">
            <p className="terms-copyright">© {currentYear} Quizzer - {t('droitsReserves')}</p>
          </footer>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms; 